import {useForm} from "react-hook-form";
import React, {Fragment, useState} from "react";
import {updateCommunicationsPlanDetails} from "root/DataFunctions/CommunicationsPlanDataFns";
import useAutoForm from "./FormComponents/useAutoForm";
import {ModalSaveButton} from "root/Modals/buttons";
const HookFormAgreements = ({ child_uid, communications_plan_id, rows, onClickCancel, onSaveComplete }) =>
{
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const FORM_NAME = 'contact' ;

    const { isReady, fieldsToWatch, formFields, sections, renderSections, preProcessFormData } = useAutoForm( { formName: FORM_NAME, rows }) ;

    const {register, control, handleSubmit, setFocus, watch, setValue,
        formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                [FORM_NAME] : formFields
            }
        });

    const watchFieldContents = watch(fieldsToWatch) ;

    const doSave = (formData) =>
    {
        updateCommunicationsPlanDetails( child_uid, communications_plan_id, formData, (response) =>
        {
            onSaveComplete() ;
        })
    }

    const onSubmit = (data) =>
    {
        const dataForSubmission = preProcessFormData ( data[FORM_NAME] ) ;

        const postData = {
            mode: 'update',
            [FORM_NAME]: dataForSubmission,
        }

        doSave(postData);
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    return (
        <Fragment>
            <form className='registration-form' onSubmit={handleSubmit(onSubmit)} key='rform'>
                    { isReady === true && renderSections( sections, sections.length > 1, control, register, formErrors, watchFieldContents )}
            </form>

            <div className="d-flex flex-row justify-content-end" key='buttonrow'>
                <button key='canbtn' onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left"/></button>
                <ModalSaveButton key='savbtn' disabledFlag={buttonDisabled} onClick={onClickSaveForm}>Save</ModalSaveButton>
            </div>

        </Fragment>
    )

}

export default HookFormAgreements;